module.exports = __webpack_public_path__ + "static/media/key-cmp-blue.bd8d16de.svg";